export class UpdateConveyanceSegmentConfigRequest {
  ConveyanceSegmentID: number;
  ConfigName: string;
  ConfigValue: string;
}
